import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  getFromStorage,
  saveToStorage,
} from "../../utils/functions/localStorage";
import { ROUTES } from "../../utils/constants";

const EXCLUDED_PATHS: readonly string[] = [
  ROUTES.PRIVACY_POLICY,
  ROUTES.USER_AGREEMENT,
  ROUTES.PERSONAL_DATA_AGREEMENT,
];

export const useAppPromotion = () => {
  const [modalActive, setModalActive] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Только при монтировании проверяем путь
    if (EXCLUDED_PATHS.includes(location.pathname)) {
      setModalActive(false);
      return;
    }

    // const appsShowed = getFromStorage("appsShowed");
    // if (!appsShowed) {
      setModalActive(true);
    //   saveToStorage("appsShowed", true);
    // }
  }, []); // ✅ Пустой массив — только 1 раз при монтировании

  return { modalActive, setModalActive };
};